import { Box, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { BaseBoxWhite } from "../util/BaseBox";
import { BorderBottomTypography } from "../util/BorderBottomTypography";

export default function Vision() {
    const theme = useTheme();
    const isDownLg = useMediaQuery(theme.breakpoints.down("lg"));
    const { t } = useTranslation("conditionagent");

    const visionData = t("vision", { returnObjects: true }) as any;

    const containerStyles = {
        padding: "85.5px 0px 198px 0px",
        [theme.breakpoints.down("sm")]: {
            paddingTop: "47.3px",
            paddingBottom: "90.2px",
        },
    };

    return (
        <React.Fragment>
            <BaseBoxWhite containerStyles={containerStyles}>
                <BorderBottomTypography containerStyles={{}}>{visionData?.title}</BorderBottomTypography>
                <Box
                    textAlign="center"
                    sx={{
                        height: "auto",
                        paddingTop: "83px",
                        [theme.breakpoints.down("sm")]: {
                            paddingTop: "25px",
                        },
                    }}
                >
                    <Grid
                        container
                        rowSpacing={0}
                        columnSpacing={{}}
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{
                            [theme.breakpoints.down("lg")]: {
                                flexDirection: "column",
                                alignItems: "center",
                            },
                        }}
                    >
                        <Grid
                            item
                            lg={4.2}
                            xs={12}
                            sx={{
                                textAlign: {
                                    xs: "center",
                                    lg: "left",
                                },
                                [theme.breakpoints.down("lg")]: {
                                    order: 2,
                                },
                            }}
                        >
                            <Box
                                display="block"
                                component="img"
                                width={"100%"}
                                maxWidth={347.43}
                                sx={{
                                    verticalAlign: "bottom",
                                    [theme.breakpoints.down("lg")]: {
                                        display: "none",
                                    },
                                }}
                                alt="Condition Agent logo and message"
                                src="/images/walccare/Condition Agent Logo_color_02.png"
                            />
                            <Typography
                                sx={{
                                    fontFamily: "Inter",
                                    fontWeight: "400",
                                    fontSize: "20px",
                                    letterSpacing: "-30 / 1000 * 20px",
                                    textAlign: "left",
                                    padding: "23px 0px 0px 0px",
                                    [theme.breakpoints.down("lg")]: {
                                        fontSize: "16px",
                                        padding: "30px 20px 0px 20px",
                                    },
                                }}
                            >
                                {visionData?.body}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            lg={7.8}
                            xs={12}
                            sx={{
                                textAlign: {
                                    xs: "center",
                                    lg: "right",
                                },
                                [theme.breakpoints.down("lg")]: {
                                    order: 1,
                                },
                            }}
                        >
                            <Box
                                component="img"
                                width="100%"
                                height="auto"
                                maxWidth={952}
                                sx={{
                                    verticalAlign: "bottom",
                                    [theme.breakpoints.down("lg")]: {
                                        maxWidth: "100%",
                                        aspectRatio: 1352 / 1968,
                                    },
                                }}
                                alt="Condition Agent concept"
                                src={visionData?.image}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </BaseBoxWhite>
        </React.Fragment>
    );
}
